import { CustomFunction } from "@ceeferenderer/itg-renderer-sdk/model/common";
import { ICustomFunctionValueType } from "@ceeferenderer/itg-renderer-sdk";
import { getTargets, getValues, isFutureDate, notifyTargets } from "../../utils/dateValidation";

type DateType = "month" | "year";

const validateDateType = (dateType: string): dateType is DateType => /^(month|year)$/.test(dateType);

const isValueFilled = (value: ICustomFunctionValueType): boolean =>
  !!value && Array.isArray(value) && (value as string[]).every(Boolean);

const lock: Record<string, boolean> = {};

export const pairDate: CustomFunction = (value, _, input) => {
  const dateType = input?.getAttribute("data-date-type");
  if (!input || !dateType || !validateDateType(dateType)) {
    throw new Error();
  }
  const targets = getTargets(
    {
      month: "data-month",
      year: "data-year",
    },
    input
  );
  const values = getValues(targets);

  const lockId = targets.month.getAttribute("rsmonitor") || dateType;
  if (!lock[lockId] && values.month && values.year) {
    lock[lockId] = true;
    notifyTargets(dateType, targets);
    lock[lockId] = false;
  }
  return {
    message: `Please select a valid ${dateType} to continue`,
    value: !isFutureDate(values.month, values.year) && isValueFilled(value),
  };
};
